import React from "react";
import PropTypes from "prop-types";
import MarkerGroup from "./markerGroup";
import { FormattedMessage } from "react-intl";

const ScreeningGroup = ({ data, basic }) => {
  const title = data.name;
  const description = !basic && (
    <p>
      <FormattedMessage
        id={(data.description || "").trim()}
        defaultMessage={data.description}
      />
    </p>
  );
  const subcategories = data.subcategories
    ? data.subcategories
    : data.subCategories;

  const markerGroups = []
    .concat(subcategories)
    .map((group, idx) => (
      <MarkerGroup
        key={group.biomarkerSubCategorId || idx}
        data={group}
        basic={basic}
        hasDetails={true}
      />
    ));

  return (
    <article className="card apl-marker__screening-group">
      <header>
        <h3>
          <FormattedMessage id={(title || "").trim()} defaultMessage={title} />
        </h3>
      </header>
      <section>{description}</section>
      {markerGroups}
    </article>
  );
};

ScreeningGroup.propTypes = {
  data: PropTypes.object.isRequired,
  basic: PropTypes.bool,
};

export default ScreeningGroup;



// WEBPACK FOOTER //
// ./components/employee/wellness/screeningGroup.jsx